import PopulatesFrom from "./PopulatesFrom";
export default PopulatesFrom;
